<div *ngIf="showFilter && showSurveySelector">
  <button
    class="tw-rounded-full md:tw-w-fit tw-w-14 tw-h-14 tw-bg-white tw-text-main tw-shadow-1 tw-flex tw-justify-center md:tw-px-7 md:tw-py-2 focus:tw-outline-0 hover:tw-bg-gray-50 disabled:tw-opacity-60 disabled:tw-cursor-not-allowed"
    (click)="isOpen = !isOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    [class.!tw-bg-main]="isOpen"
    [class.!tw-text-white]="isOpen"
    id="surveyWrapperTrigger"
  >
    <mh-spinner-classic [hidden]="!waiting"></mh-spinner-classic>
    <ng-container *ngIf="!waiting">
      <i class="fas fa-align-left tw-self-center tw-text-lg md:tw-text-base"></i>
      <span class="tw-hidden tw-ml-2 md:tw-inline-block tw-text-base tw-font-medium tw-self-center tw-text-main-text" [class.!tw-text-white]="isOpen">
        
        <!-- Modo selección única -->
        <ng-container *ngIf="!multipleSelectionMode">
          {{'commons.surveys' | translate}}:
          <ng-container *ngIf="selectedSurvey !== 0">
            <span mhFindTranslate [language]="language" [translates]="currentSurvey.survey[0].translates" [keyTranlsate]="'title'"></span>
          </ng-container>
          
          <ng-container *ngIf="selectedSurvey === 0">
            {{ 'commons.alls' | translate }}
          </ng-container>
        </ng-container>

        <!-- Modo selección múltiple -->
        <ng-container *ngIf="multipleSelectionMode">
          <ng-container *ngIf="selectedCount === 0">
            {{'shared.filters.hotels.no_selection' | translate}}
          </ng-container>
          
          <ng-container *ngIf="selectedCount > 0 && selectedCount === totalCount">
            {{ 'commons.all_surveys' | translate }}
          </ng-container>
          
          <ng-container *ngIf="selectedCount > 0 && selectedCount < totalCount">
            <span [title]="selectedSurveyNames.join(', ')" class="tw-cursor-help">
              {{'commons.surveys' | translate}} ({{selectedCount}})
            </span>
          </ng-container>
        </ng-container>

      </span>
    </ng-container>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="multipleSelectionMode"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="multipleSelectionMode ? null : (isOpen = false)"
  >
    <article class="tw-rounded-lg tw-shadow-xl tw-bg-white tw-mt-1 tw-w-[350px] tw-max-w-[90vw] tw-z-[1000] tw-border-none tw-max-h-[80vh] tw-flex tw-flex-col" id="surveyWrapperMenu">
      
      <!-- Header con botones para selección múltiple -->
      <div class="tw-p-3 tw-border-b tw-border-gray-200" *ngIf="multipleSelectionMode">
        <div class="tw-mb-2 tw-font-medium">{{'commons.surveys' | translate}}:</div>
        
        <div class="tw-flex tw-gap-2">
          <button 
            type="button"
            class="tw-text-xs tw-px-2 tw-py-1 tw-bg-blue-100 tw-text-blue-700 tw-rounded hover:tw-bg-blue-200 tw-transition-colors"
            (click)="selectAllSurveys()"
            *ngIf="!allSelected">
            {{'shared.filters.hotels.select_all' | translate}}
          </button>
          <button 
            type="button"
            class="tw-text-xs tw-px-2 tw-py-1 tw-bg-gray-100 tw-text-gray-700 tw-rounded hover:tw-bg-gray-200 tw-transition-colors"
            (click)="deselectAllSurveys()"
            *ngIf="allSelected">
            {{'shared.filters.hotels.deselect_all' | translate}}
          </button>
        </div>
      </div>

      <!-- Contenido del dropdown -->
      <div class="tw-p-3" [ngClass]="{'tw-flex-1 tw-overflow-y-auto': multipleSelectionMode}">
        
        <!-- Selección única (modo radio) -->
        <ng-container *ngIf="!multipleSelectionMode">
          <mat-radio-group class="tw-flex tw-flex-col tw-w-full" [(ngModel)]="selectedSurvey" (change)="setCurrentSurvey($event.value)">
            <mat-radio-button class="tw-my-1" [value]="0" *ngIf="showOptionAll">
              {{ 'commons.alls' | translate }}
            </mat-radio-button>

            <ng-container *ngIf="!isChain">
              <mat-radio-button class="tw-my-1" *ngFor="let survey of listSurveys" [value]="survey.id">
                <ng-container [ngSwitch]="survey.version">
                  <ng-container *ngSwitchCase="1">
                    {{ 'survey.types.'+survey.type.id | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <span mhFindTranslate [language]="language" [translates]="survey.translates" [keyTranlsate]="'title'"></span>
                  </ng-container>
                </ng-container>
              </mat-radio-button>
            </ng-container>

            <ng-container *ngIf="isChain">
              <mat-radio-button class="tw-my-1" *ngFor="let type of listTypes" [value]="type.type">
                <ng-container [ngSwitch]="type.version">
                  <ng-container *ngSwitchCase="1">
                    {{ 'survey.types.'+type.type | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <span mhFindTranslate [language]="language" [translates]="type.translates" [keyTranlsate]="'title'"></span>
                  </ng-container>
                </ng-container>
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </ng-container>

        <!-- Selección múltiple (modo checkbox) -->
        <ng-container *ngIf="multipleSelectionMode">
          <div class="tw-flex tw-flex-col tw-w-full">
            
            <ng-container *ngIf="!isChain">
              <mat-checkbox 
                class="tw-my-1 tw-max-w-full" 
                *ngFor="let survey of listSurveys" 
                [checked]="isSurveySelected(survey.id)"
                (change)="toggleSurveySelection(survey.id)">
                <span class="tw-block tw-truncate tw-max-w-[280px]">
                  <ng-container [ngSwitch]="survey.version">
                    <ng-container *ngSwitchCase="1">
                      {{ 'survey.types.'+survey.type.id | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                      <span mhFindTranslate [language]="language" [translates]="survey.translates" [keyTranlsate]="'title'"></span>
                    </ng-container>
                  </ng-container>
                </span>
              </mat-checkbox>
            </ng-container>

            <ng-container *ngIf="isChain">
              <mat-checkbox 
                class="tw-my-1 tw-max-w-full" 
                *ngFor="let type of listTypes" 
                [checked]="isSurveySelected(type.type)"
                (change)="toggleSurveySelection(type.type)">
                <span class="tw-block tw-truncate tw-max-w-[280px]">
                  <ng-container [ngSwitch]="type.version">
                    <ng-container *ngSwitchCase="1">
                      {{ 'survey.types.'+type.type | translate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                      <span mhFindTranslate [language]="language" [translates]="type.translates" [keyTranlsate]="'title'"></span>
                    </ng-container>
                  </ng-container>
                </span>
              </mat-checkbox>
            </ng-container>

          </div>
        </ng-container>

      </div>
    </article>
  </ng-template>
</div>

<ng-content *ngIf="showContent"></ng-content>
